export default "__VITE_ASSET__BIGRucYz__"